import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../../Components/Form";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import { CadastrarReguaController } from "../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";

interface ICadastrarReguaProps {
    then: () => void;
}

interface IFormDataCadastrar {
    DS_REGUA: string;
}

export default function CadastrarRegua(props: ICadastrarReguaProps) {
    const form = useForm();
    const { reset } = form;

    const { execute: handleCadastrarReguaFormSubmit, loading } =
        useAsyncCallback(async (formData: IFormDataCadastrar) => {
            await CadastrarReguaController({
                DS_NOME_REGUA: formData.DS_REGUA,
            }).then(() => {
                reset();
                props.then();
            });
        });

    return (
        <FormProvider {...form}>
            <div className="text-center mb-10">
                <h2 className="font-weight-bold">Cadastro de Régua</h2>
            </div>
            <UnForm usingContext handleSubmit={handleCadastrarReguaFormSubmit}>
                <div className="form-group border-bottom py-3 b-5">
                    <UnForm.Input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75`}
                        placeholder="Nome"
                        name="DS_REGUA"
                        registerOptions={{
                            required: "Insira o nome da régua",
                        }}
                        autoComplete="off"
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2 d-flex align-items-center justify-content-center g-3"
                        disabled={loading}
                    >
                        {loading && <Spinner size="sm" />}
                        Cadastrar
                    </button>
                </div>
            </UnForm>
        </FormProvider>
    );
}
